<nz-tabset
  [nzSelectedIndex]="_displayIndex"
  (nzSelectedIndexChange)="onTabChange($event)"
  [nzType]="styleType === 'Card' ? 'card' : 'line'"
  class="full-size"
  [nzCentered]="styleType === 'Card'"
  [nzSize]="size ?? (styleType === 'Card' ? 'small' : 'default')"
  [ngClass]="styleType === 'Card' ? 'card-style' : ''"
>
  <nz-tab *ngFor="let tab of tabs; let i = index" [nzTitle]="titleTemplate" [nzDisabled]="tab.disabled">
    <ng-template #titleTemplate>
      <span *ngIf="tab.icon && tab.tooltipText" nz-tooltip [nzTooltipTitle]="tab.tooltipText">
        <svg-icon class="tooltip-icon" [src]="tab.icon"></svg-icon>
      </span>
      {{ tab.title }}
      <span *ngIf="tab.showDot" class="gains-tab-dot" aria-hidden="true"></span>
    </ng-template>
    <ng-container *ngIf="selectedIndex === i">
      <ng-container *ngTemplateOutlet="tab.template"></ng-container>
    </ng-container>
  </nz-tab>
</nz-tabset>
